import type { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import { noop } from 'lodash';
import type { FC, PropsWithChildren } from 'react';
import React, { createContext, useContext, useMemo } from 'react';

interface GroupCreateModalContextProps {
  readonly showContent: () => void;
  readonly isUniversalCreateButton: boolean;
}

const defaultGroupCreateModalContext: GroupCreateModalContextProps = {
  showContent: noop,
  isUniversalCreateButton: false,
};

const GroupCreateModalContext = createContext<GroupCreateModalContextProps>(defaultGroupCreateModalContext);
export const useShowGroupCreateModal = (): (() => void) =>
  useContext<GroupCreateModalContextProps>(GroupCreateModalContext).showContent;

export const useIsUniversalCreateButton = (): boolean =>
  useContext<GroupCreateModalContextProps>(GroupCreateModalContext).isUniversalCreateButton;

export interface CreateCommunityProviderProps {
  readonly useGroupCreateModal: () => ReturnType<typeof useRenderToggleableContent>;
}

export const CreateCommunityProvider: FC<PropsWithChildren<CreateCommunityProviderProps>> = ({
  useGroupCreateModal,
  children,
}) => {
  const { showContent, content } = useGroupCreateModal();

  const value = useMemo(
    () => ({
      showContent,
      isUniversalCreateButton: true,
    }),
    [showContent]
  );

  return (
    <GroupCreateModalContext.Provider value={value}>
      {children}
      {content}
    </GroupCreateModalContext.Provider>
  );
};
